module.exports = __webpack_public_path__ + "img/promy-logo-wh@3x.e4a16073.png";